var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ 
    display: 'inline-block', 
    width: '50px', 
    height: '25px', 
    backgroundColor: _vm.value ? '#4CD964' : '#e5e5e5', 
    borderRadius: '15px', 
    transition: 'background-color 0.2s', 
    position: 'relative', 
    border: '1px solid #e5e5e5',
    cursor: 'pointer',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  }),on:{"click":_vm.toggle}},[_c('div',{style:({ 
      width: '20px', 
      height: '20px', 
      borderRadius: '50%', 
      backgroundColor: '#fff', 
      position: 'absolute', 
      top: '2.5px', 
      left: _vm.value ? '25px' : '2.5px', 
      transition: 'left 0.2s', 
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }